// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

.dynamic-form {
  padding: 1px 20px 20px;
}

.dynamic-form.form2 {
  padding: 1px 20px 0 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/fill-form/fill-form.component.scss","webpack://./../mydocma-dynamic-form-app%20(dev)/src/app/components/fill-form/fill-form.component.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;ACCJ;;ADEA;EACI,sBAAA;ACCJ;;ADEA;EACI,wBAAA;ACCJ","sourcesContent":["* {\r\n    box-sizing: border-box;\r\n}\r\n\r\n.dynamic-form {\r\n    padding: 1px 20px 20px;\r\n}\r\n\r\n.dynamic-form.form2{\r\n    padding: 1px 20px 0 15px;\r\n}\r\n","* {\n  box-sizing: border-box;\n}\n\n.dynamic-form {\n  padding: 1px 20px 20px;\n}\n\n.dynamic-form.form2 {\n  padding: 1px 20px 0 15px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
